import jQuery from 'jquery';
import {createAction} from 'redux-actions';
import find from 'lodash/find';

import {Notification} from './actions';
import {Priority} from './constants';

let LocalNotificationID = 0;

const addNotificationAction = createAction(Notification.add);

export const addNotification = (text, tags, priority = Priority.HIGH) => dispatch => {
    const id = `local-${LocalNotificationID++}`;
    const notification = {id, text, tags, priority};

    return dispatch(addNotificationAction(notification));
};

const confirmNotificationAction = createAction(Notification.confirm);

export const confirmNotification = id => (dispatch, getState) => {
    const {notifications, confirmNotificationURL, CSRFMiddlewareToken} = getState();
    const notification = find(notifications, {id}) || null;

    if (notification === null) return;

    dispatch(confirmNotificationAction(id));

    if (typeof id === 'string' && id.indexOf('local') === 0) return;

    const error = () => dispatch(addNotificationAction(notification));

    jQuery.ajax(confirmNotificationURL, {
        method: 'POST',
        data: {
            notification: id,
            csrfmiddlewaretoken: CSRFMiddlewareToken,
        },
        dataType: 'json',
        success: ({success}) => {
            if (!success) error();
        },
        error,
    });
};

export const initialNotifications = createAction(Notification.initial);
